<mat-card class="essential-data-card">
  <mat-card-content *ngIf="district">
    <div class="mobile-layout">
      <!-- Left side: Map and Profile -->
      <div class="profile-section">
        <!-- District Map with buttons -->
        <div class="map-container map-clickable" (click)="openMapInNewWindow()" role="button" tabindex="0" (keydown.enter)="openMapInNewWindow()" (keydown.space)="openMapInNewWindow()" title="Click to open map in new window (view full size and download)">
          <div class="map-section">
            <img [src]="district.mapPath" alt="Map of {{ district.districtName }} - click to open in new window" class="map-image" />
          </div>
        </div>

        <!-- District Name -->
        <h3 class="district-name profile-link" (click)="openProfile()" role="button" tabindex="0" (keydown.enter)="openProfile()" (keydown.space)="openProfile()">
          Profile of {{ district.districtName }}
        </h3>
      </div>

      <!-- Right side: Essential Data -->
      <div class="data-section">
        <!-- Essential Data Heading -->
        <h3 class="essential-data-heading">Essential data</h3>

        <!-- Essential Statistics Table -->
        <table *ngIf="turnout" class="essential-stats-table">
          <tr>
            <td class="label">Electors enrolled</td>
            <td class="value">{{ turnout.electorsEnrolled | number }}</td>
            <td class="percent"></td>
          </tr>

          <ng-container *ngIf="isFinal">
            <tr>
              <td class="label">Votes cast</td>
              <td class="value">{{ turnout.votesCast | number }}</td>
              <td class="percent"></td>
            </tr>
          </ng-container>

          <ng-container *ngIf="!isFinal">
            <tr>
              <td class="label">Votes counted</td>
              <td class="value">{{ turnout.votesCounted | number }}</td>
              <td class="percent"></td>
            </tr>
          </ng-container>

          <tr>
            <td class="label">Formal votes</td>
            <td class="value">{{ turnout.formalVotes | number }}</td>
            <td class="percent">
              ({{ turnout.formalPercent / 100 | percent: "1.1-1" }})
            </td>
          </tr>

          <tr>
            <td class="label">Informal votes</td>
            <td class="value">{{ turnout.informalVotes | number }}</td>
            <td class="percent">
              ({{ turnout.informalPercent / 100 | percent: "1.1-1" }})
            </td>
          </tr>

          <ng-container *ngIf="isFinal">
            <tr>
              <td class="label">Turnout</td>
              <td class="value">
                {{ turnout.turnoutPercent / 100 | percent: "1.1-1" }}
              </td>
              <td class="percent"></td>
            </tr>
          </ng-container>
        </table>
      </div>
    </div>
  </mat-card-content>
</mat-card>
